<ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <ng-container [ngSwitch]="mode">
        <ng-container *ngSwitchCase="'nohomesmall'">
            {{zielText}}
        </ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mbfilters"></ng-container>
    </ng-container>
</ng-template>
<ng-template #mbfilters>
    <button class="tmpbtn w100" [class.bottomleftradius]='bottomleftradius'
        [class.bottomrightradius]='bottomrightradius' [class.topleftradius]='topleftradius'
        [class.toprightradius]='toprightradius' [class.norightborder]='norightborder'
        [class.nobottomborder]='nobottomborder' #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <ng-container *ngTemplateOutlet="iconn"></ng-container>
        <span multilang>{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #homemodeMobile>
    <button class="tmpbtn  w100" [class.bottomleftradius]='bottomleftradius'
        [class.bottomrightradius]='bottomrightradius' [class.topleftradius]='topleftradius'
        [class.toprightradius]='toprightradius' [class.norightborder]='norightborder'
        [class.nobottomborder]='nobottomborder' [class.tmp-bottom-left]="bottomleftradius"
        [class.tmp-no-bottom-border]="!bottomleftradius" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <ng-container *ngTemplateOutlet="iconn"></ng-container>
        <span multilang>{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #homefilterdesk>
    <button class="tmpbtn w100" [class.bottomleftradius]='bottomleftradius'
        [class.bottomrightradius]='bottomrightradius' [class.topleftradius]='topleftradius'
        [class.toprightradius]='toprightradius' [class.norightborder]='norightborder'
        [class.nobottomborder]='nobottomborder' #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModal($event)" matRipple>
        <ng-container *ngTemplateOutlet="iconn"></ng-container>
        <span multilang>{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #modal>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mobileDesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #mobileDesk>
    <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <input type="text" placeholder="{{title}} hinzufügen" [formControl]="mySearchControl" ng-focus
                    [appAutoFocus]="focus" class="searchinput">
                <button matRipple (click)="clearText()" *ngIf="mySearchControl?.value?.length > 0">
                    <mat-icon class="btnico">clear</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <button matRipple (click)="closeModalMobile()">
                    <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                </button>
                <input type="text" placeholder="{{title}} hinzufügen" [formControl]="mySearchControl" ng-focus
                    [appAutoFocus]="focus" class="searchinput">
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper customscrolls" [class.f-bodywrapper-mobile]="media === 'xs' || media=== 'sm'">
        <ng-container *ngIf="selectedList?.length > 0">
            <div class="selected-wrapper">
                <button class="selected-item-alle" (click)="removeAllSelected()">
                    <span multilang>Alles löschen</span>
                </button>
                <ng-container *ngFor="let item of selectedList; let k = index">
                    <div class="selected-item">
                        <span multilang>{{item.name}} <span multilang class="second-item-line"
                                *ngIf="showVc">{{item?.vc}}</span></span>
                        <button (click)="removeFromSelected(k)">
                            <mat-icon class="clearbtn">clear</mat-icon>
                        </button>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <ng-container *ngFor="let item of (searchObj | async)">
            <ng-container *ngIf="isNotInlist(item)">
                <button class="item-wrapper" (click)="selectValue(item)">
                    <div class="item-body">
                        <span multilang class="first-item-line">{{item.name}} <span class="second-item-line"
                                *ngIf="showVc">{{item?.vc}}</span></span>
                    </div>
                </button>
            </ng-container>
        </ng-container>
    </div>
    <div class="ubwrapper">
        <button class="ubbtn" (click)="take()" multilang>ÜBERNEHMEN</button>
    </div>
</ng-template>


<ng-template #iconn>
    <ng-container [ngSwitch]="icon">
        <ng-container *ngSwitchCase="'directions_boat'" [ngTemplateOutlet]="directions_boat1"></ng-container>
        <ng-container *ngSwitchCase="'verified'" [ngTemplateOutlet]="verified1"></ng-container>
        <ng-container *ngSwitchCase="'place'" [ngTemplateOutlet]="place1"></ng-container>
        <ng-container *ngSwitchCase="'timelapse'" [ngTemplateOutlet]="timelapse1"></ng-container>
        <ng-container *ngSwitchCase="'people_alt'" [ngTemplateOutlet]="people_alt1"></ng-container>
        <ng-container *ngSwitchCase="'flight'" [ngTemplateOutlet]="flight1"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="houseboat1"></ng-container>
    </ng-container>
</ng-template>

<ng-template #flight1>
    <mat-icon fontIcon="flight"></mat-icon>
</ng-template>

<ng-template #people_alt1>
    <mat-icon fontIcon="people_alt"></mat-icon>
</ng-template>

<ng-template #directions_boat1>
    <mat-icon fontIcon="directions_boat"></mat-icon>
</ng-template>

<ng-template #verified1>
    <mat-icon fontIcon="verified"></mat-icon>
</ng-template>

<ng-template #place1>
    <mat-icon fontIcon="place"></mat-icon>
</ng-template>

<ng-template #timelapse1>
    <mat-icon fontIcon="timelapse"></mat-icon>
</ng-template>

<ng-template #houseboat1>
    <mat-icon fontIcon="houseboat"></mat-icon>
</ng-template>